import { ScheduledJob, ScheduledJobType } from '@shure/cloud/shared/models/devices';

import { ScheduledJobFragment } from '../graphql/generated/cloud-sys-api';

export function mapScheduledJobFromSysApi(scheduledJob: ScheduledJobFragment): ScheduledJob {
	return {
		id: scheduledJob.id,
		jobId: scheduledJob.jobId,
		name: scheduledJob.name,
		type: scheduledJob.type as ScheduledJobType, // TODO: remove cast and handle other job types
		status: scheduledJob.status,
		requestCount: scheduledJob.requestCount,
		executeAt: new Date(scheduledJob.executeAt),
		createdBy: scheduledJob.createdBy,
		createdAt: new Date(scheduledJob.createdAt),
		updatedBy: scheduledJob.updatedBy,
		updatedAt: new Date(scheduledJob.updatedAt)
	};
}
